import { useState, useEffect } from 'react';
import moment from 'moment';
import ErrorHandler from '@Root/ErrorHandler';
import Popover from '@mui/material/Popover';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './FormStats.scss';

export default function FormStats(props) {

    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState({});
    const [kaiziqResolveConnectionStats, setKaiziqResolveConnectionStats] = useState({});
    const [anchorComingSoonPopover, setAnchorComingSoonPopover] = useState(null);
    new ErrorHandler();
    const className = 'ticketDashboards__formStats';

    useEffect(() => {
        setKaiziqResolveConnectionStats(props.kaiziqResolveConnectionStats);
        setKaiziqResolveConnection(props.kaiziqResolveConnection);
    }, [props])

    const Capitalize = (str) => {
        return str?.charAt(0)?.toUpperCase() + str?.slice(1);
    }

    const handleComingSoonPopoverClose = () => {
        setAnchorComingSoonPopover(null);
    };

    return (
        <div className={className}>
            <div className={className + '__top flex-row-center-space-between width-wfa'}>
                <div className={className + '__top__t1 semi-bold-text'}>
                    Overview
                </div>
            </div>
            <div className={className + '__stats flex-column-flex-start-1vh-gap width-wfa'}>
                <div className={className + '__stats__visibility flex-row-center-space-between width-wfa'}>
                    <div className={className + '__stats__visibility__t1'}>
                        Visibility &nbsp;
                    </div>
                    <div className={className + '__stats__visibility__t2 semi-bold-text blue-text'}>
                        {Capitalize(kaiziqResolveConnection?.visibility)}
                    </div>
                </div>
                <div className={className + '__stats__accessType flex-row-center-space-between width-wfa'}>
                    <div className={className + '__stats__accessType__t1 '}>
                        Access Type &nbsp;
                    </div>
                    <div className={className + '__stats__accessType__t2 semi-bold-text blue-text'}>
                        {
                            kaiziqResolveConnection?.accessType === 'public_open' &&
                                <>Open</>
                        }
                        {
                            (kaiziqResolveConnection?.accessType === 'public_verified' || kaiziqResolveConnection?.accessType === 'private_verified') &&
                                <>Account Verified</>
                        }
                        {
                            (kaiziqResolveConnection?.accessType === 'public_email' || kaiziqResolveConnection?.accessType === 'private_email') &&
                                <>Email Verified</>
                        }
                    </div>
                </div>
                <div className={className + '__stats__createTimeStamp flex-row-center-space-between width-wfa'}>
                    <div className={className + '__stats__createTimeStamp__t1'}>
                        Created &nbsp;
                    </div>
                    <div className={className + '__stats__createTimeStamp__t2 semi-bold-text blue-text'}>
                         {moment(new Date(kaiziqResolveConnection?.createTimeStamp),'DD-MM-YYYY').fromNow()}
                    </div>
                </div>
                <div className={className + '__stats__totalIssues flex-row-center-space-between width-wfa'}>
                {
                    props.formType === 'reports' ?
                        <>
                            <div className={className + '__stats__totalIssues__t1'}>
                                Total Tickets & Responses
                            </div>
                            <div className={className + '__stats__totalIssues__value semi-bold-text blue-text'}>
                                {kaiziqResolveConnectionStats?.ticketCount}
                            </div>
                        </>
                    :
                        <>
                            <div className={className + '__stats__totalIssues__t1'}>
                                {props.formType === 'ticket' && 'Total Tickets'}
                                {props.formType === 'issue' && 'Total Issues Reported'}
                                {props.formType === 'feedback' && 'Total Responses'}
                            </div>
                            <div className={className + '__stats__totalIssues__value semi-bold-text blue-text'}>
                                {kaiziqResolveConnectionStats?.ticketCount}
                            </div>
                        </>
                }
                </div>
                <div className={className + '__stats__totalReporters flex-row-center-space-between width-wfa'}>
                    <div className={className + '__stats__totalReporters__t1'}>
                        Total Reporters
                    </div>
                    <div className={className + '__stats__totalReporters__value semi-bold-text blue-text'}>
                        {props?.kaiziqResolveConnectionAnalytics?.reporters}
                    </div>
                </div>
                <div className={className + '__stats__totalPermissions flex-row-center-space-between width-wfa'}>
                    <div className={className + '__stats__totalReporters__t1'}>
                        Total Permissions
                    </div>
                    <div className={className + '__stats__totalReporters__value semi-bold-text blue-text'}>
                        {kaiziqResolveConnectionStats?.emailCount}
                    </div>
                </div>
            </div>
            <Popover
                id='mouse-over-coming-soon'
                sx={{
                    pointerEvents: 'none',
                }}
                open={Boolean(anchorComingSoonPopover)}
                anchorEl={anchorComingSoonPopover}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                onClose={handleComingSoonPopoverClose}
                disableRestoreFocus>
                <div className={className + '__comingSoon'}>
                    Coming Soon!
                </div>
            </Popover>
        </div>
    );
}

